import * as React from 'react';
import Ellipse from 'components/src/svg/Ellipse';

type Props = {
  children: React.ReactNode;
  classes?: string;
};

const ListItem = ({ children, classes }: Props) => {
  return (
    <li className={`${classes} flex w-full items-center text-black-100`}>
      <div className={`mt-2 self-start px-8 py-8 text-black-100`}>
        <Ellipse />
      </div>
      {children}
    </li>
  );
};
export default ListItem;
